import { apiClient } from '../lib/api-client';
import { useQuery } from "@tanstack/react-query";

interface SendSupportEmailResult {
    isSuccess: boolean;
    errorMessage: string;
}

export async function sendSupportEmail(supportEmail: string, userName: string, firstname: string, lastname: string, userPhone: string, userEmail: string, cfiCompany: string, application: string, topic: string, message: string) {
    try {
        // Send request
        let data: SendSupportEmailResult = await apiClient.post("help/send-support-email", {
            supportEmail: supportEmail,
            userName: userName,
            userFirstname: firstname,
            userLastname: lastname,
            userPhone: userPhone,
            userEmail: userEmail,
            cfiCompany: cfiCompany,
            application: application,
            topic: topic,
            message: message
        });

        return {
            isOk: data.isSuccess,
            message: data.errorMessage
        };

    } catch {
        return {
            isOk: false,
            message: 'Sending failed'
        };
    }
}

export interface GetUserInfoResult {
    userName: string,
    firstName: string,
    lastName: string,
    phone: string,
    emailAddress: string,
    avatar: string
}

export const useGetSupportSpecialist = (companyID: number) => {
    const { data, isLoading } = useQuery({
        queryKey: ['get-support-specialist', companyID],
        queryFn: async () => await apiClient.get('help/get-support-specialist', {
            params: {
                companyID: companyID
            }
        }) as GetUserInfoResult
    });

    return {
        data,
        isLoading
    };
};

